import React, { useState, useEffect, useRef } from "react"
import { useLocation } from 'react-router-dom'
import {
    Form,
    Input,
    Button,
    Col,
    Row,
    Carousel,
    Spin,
    Modal,
    Checkbox
} from "antd"
import { RightOutlined } from "@ant-design/icons"
import * as com from "./Common.js"
import EmailVerification from "./Application/EmailVerification.js"
import { RecaptchaV3, RecaptchaV3SiteKey } from "./Recaptcha.js"
import { Redirect, withRouter } from "react-router-dom"
import {
    UR_LoanOfficerManager,
    UR_LoanProcessor,
    UR_Owner,
    UR_PriceEngineUser,
    UR_Underwriter,
    UR_Closer,
} from "./State.js"
import { checkAccessByToken } from "./Auth.js"
import "./LoginPage.css"
import cookie from 'react-cookies'
import LoginPage from './LoginGooglePage.js'
import AppleSignIn from './AppleSignIn.js'
import OutlookSignIn from './OutlookSignIn.js'
import { useSelector, useDispatch } from 'react-redux'
import { useStatsigClient } from "@statsig/react-bindings/src";
import {updateStatsigUser} from './statsig/statsigMethod.js'
import { track, flushThenLeave } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'
import jwt_decode from "jwt-decode"
import { syncLoTokenToStrataCookies, getValidAuthToken } from "./syncStrataSession.js"

/** 登录失败上报 AUTH_LOGIN_FAIL；type 与 AUTH_LOGIN 渠道一致 */
function trackLoginFail(type, { reason = 'error', errorText } = {}) {
    track(STATSIG.AUTH.LOGIN_FAIL, type, {
        type,
        reason,
        ...(errorText ? { error_text: String(errorText).slice(0, 200) } : {}),
    })
}

const crestico_branchNamesMap = {
    "cresticofunding": "C.F. NMLSR 275201",
    "cresticofunding1244309": "C.F. NMLSR 1244309",
    "cresticofunding822418": "C.F. NMLSR 822418",
}

function Login({ 
    onSuccess, // 注册、登陆成功
    onContinue, // 自定义登陆，拿到用户输入的email
    continueText, // 自定义 原 “continue” 文本
    onToSignUp, // 切换到 “注册”
    useEmailCode, // 直接切换 使用email code 登陆
    banner, // 自定义左侧 banner
    title, // 切换title， 默认“Sign in to your account”
    description // 底部
 }) {
    const isGoogain = window.location.hostname === "team.googain.com"
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false)
    const [msg, setMsg] = useState("")
    const [showEmailVerification, setShowEmailVerification] = useState(false)
    const [customerid, setCustomerid] = useState("")
    const [redirect, setRedirect] = useState("")
    const [remember, setRemember] = useState(false)
    const [companyName, setCompanyName] = useState("")
    const [status, setStatus] = useState(2) // 1 customerId  2 Continue 3 Sign in 4 Reset your password 5 success
    const [showChooseCompany, setShowChooseCompany] = useState(false)
    const [customerIDs, setCustomerIDs] = useState([])
    const [customerType, setCustomerType] = useState("one")
    const [operationType, setOperationType] = useState("login")
    const [isEmailValid, setIsEmailValid] = useState(false)
    const [showAccountNotFound, setShowAccountNotFound] = useState(false)
    // 邮箱只对应停用账号时为 true：提示联系管理员，不再引导去注册
    const [accountDisabled, setAccountDisabled] = useState(false)
    const [company, setCompany] = useState([])
    const [isOAuthLogin, setIsOAuthLogin] = useState(false)
    const oauthLoginTypeRef = useRef('oauth')
    const formInitial = {}
    const dispatch = useDispatch()
    const { client } = useStatsigClient();

    const location = useLocation()
    const utmParamsObject = new URLSearchParams(location.search)
    const utmParams = {}
    for (const [key, value] of utmParamsObject.entries()) {
        utmParams[key] = value
    }

    useEffect(() => {
        track(STATSIG.COMMON.VIEW, PAGE.LOGIN, { page: PAGE.LOGIN })
    }, [])

    useEffect(() => {
        localStorage.removeItem('configurations')

        // 如果已有有效 token（Cookie 或 sessionStorage），直接跳转到系统内部
        const existingToken = getValidAuthToken()
        if (existingToken) {
            // 防止 PrivateRoute ↔ Login 循环：连续跳转超过 3 次就停在登录页
            const jumpCount = parseInt(sessionStorage.getItem("_loginJumpCount") || "0", 10)
            if (jumpCount >= 3) {
                sessionStorage.removeItem("_loginJumpCount")
                return // 不再跳转，停在登录页让用户手动登录
            }
            sessionStorage.setItem("_loginJumpCount", String(jumpCount + 1))
            // 确保 sessionStorage 与 Cookie 同步（Cookie 优先时需要）
            if (!sessionStorage.getItem("ZeitroA")) {
                sessionStorage.setItem("ZeitroA", existingToken)
            }
            const redirectUrl = sessionStorage.getItem("redirectAfterLogin") || "/app/welcome"
            window.location.href = redirectUrl
            return
        }
        // 没有有效 token，清除计数
        sessionStorage.removeItem("_loginJumpCount")

        if (cookie.load("remember")) {
            let cache = cookie.load("remember")
            setRemember(true)
            form.setFieldsValue({
                email: cache.username,
                password: cache.password
            })
            // 验证自动填充的邮箱格式
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            setIsEmailValid(cache.username && emailRegex.test(cache.username))
        }
        dispatch({ type: "OPEN", data: false })
    }, [])

    const getcustomeridsbyemail = () => {
        let tosend = JSON.stringify({
            Email: form.getFieldValue('email').toLowerCase(),
        })
        setLoading(true)
        fetch("/los/getcustomeridsbyemail", {
            method: "POST",
            body: tosend,
            headers: { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.status !== 200) {
                    setLoading(false)
                    console.log(
                        "Looks like there was a problem. Status Code: " + response.status
                    )
                    return
                }
                // Examine the text in the response
                response.json().then((js) => {
                    setLoading(false)
                    if (js.Status !== "OK") {
                        console.log("Error: " + js.Text)
                        setMsg(js.Text)
                    } else {
                        const filteredCustomerIDs = js.CustomerIDs.filter(customer => customer.CustomerID !== "individualcustomers")
                        // 后端会过滤掉停用账号；列表为空时用 AccountDisabled 区分"停用"和"没注册"
                        setAccountDisabled(filteredCustomerIDs.length === 0 && js.AccountDisabled === true)
                        if (filteredCustomerIDs.length === 0) {
                            setCustomerType('')
                            setCustomerid('')
                            setCustomerIDs([])
                            setShowChooseCompany(true)
                        } else if (filteredCustomerIDs.length === 1) {
                            setCustomerType('one')
                            setCustomerid(filteredCustomerIDs[0].CustomerID)
                            localStorage.setItem("customerid", filteredCustomerIDs[0].CustomerID)
                            setCompanyName(filteredCustomerIDs[0].CompanyName)
                            setStatus(prev => prev + 1)
                        } else {
                            setCustomerType('multiple')
                            setCustomerid('')
                            setCustomerIDs(filteredCustomerIDs)
                            setStatus(prev => prev + 1)
                        }
                    }
                })
            })
            .catch((err) => {
                setLoading(false)
                console.log("Fetch Error :-S", err)
            })
    }

    const onFinish = (val) => {
        if (status === 2) {
            onContinue ? onContinue(form.getFieldValue('email')) : getcustomeridsbyemail()
        } else if (status === 3) {
            setOperationType('login')
            if (customerType === 'one') {
                setLoading(true)
                window.grecaptcha.ready(() => {
                    setLoading(false)
                    window.grecaptcha
                        .execute(RecaptchaV3SiteKey, { action: "submit" })
                        .then((token) => {
                            login(token, customerid)
                        })
                })
            } else {
                setShowChooseCompany(true)
            }
        } else if (status === 5) {
            setStatus(3)
        }
    }
    const signinCode = () => {
        setOperationType('code')
        if (customerType === 'one') {
            checkEmail(customerid)
        } else {
            setShowChooseCompany(true)
        }
    }

    const useEmail = useRef(false);

    useEffect(() => {
        // 默认使用 Email code 的方式登陆
        if(!useEmail.current && status === 3 && useEmailCode){
            signinCode();
            useEmail.current = true; // 如果用户关闭过一次，就不需要在执行了
        }
    },[status, useEmailCode]);

    const checkEmail = (id) => {
        let tosend = JSON.stringify({
            email: form.getFieldValue('email').toLowerCase(),
            customerid: id,
        })
        setLoading(true)
        fetch("/los/checksigninemail", {
            method: "POST",
            body: tosend,
            headers: { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.status !== 200) {
                    setLoading(false)
                    console.log("response: ")
                    response.text().then((errorText) => {
                        let title = 'An internal error has occurred'
                        let content = 'Please try again later or contact support@zeitro.com for assistance.'
                        console.log('errorText: ' + errorText)
                        // check if customerid does not exist in database
                        if (errorText.includes('relation') && errorText.includes('does not exist')) {
                            title = 'Invalid Company ID'
                            content = 'The Company ID you entered is invalid. Please check your Company ID and try again.'
                        }
                        Modal.info({
                            title: title,
                            content: content,
                        })
                        return
                    })
                    return
                }
                response.json().then((js) => {
                    if (js.Status !== "OK") {
                        Modal.info({
                            title: 'The email has not been registered yet',
                            content: 'Please check your email or contact your company administrator for assistance.',
                        })
                    } else {
                        setShowEmailVerification(true)
                    }
                    setLoading(false)
                })
            })
            .catch(function (err) {
                setLoading(false)
                console.log("Fetch Error :-S", err)
            })
    }
    const handleClose = () => {
        setShow(false)
    }
    
    // 获取重定向 URL：如果有保存的原始 URL 则返回它，否则返回默认 URL
    const getRedirectUrl = (defaultUrl) => {
        const redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin")
        if (redirectAfterLogin) {
            sessionStorage.removeItem("redirectAfterLogin")
            return redirectAfterLogin
        }
        return defaultUrl
    }
    
    const login = (token, id) => {
        let tosend = JSON.stringify({
            username: form.getFieldValue('email').toLowerCase(),
            password: form.getFieldValue('password'),
            token: token,
            customerid: id,
        })
        setLoading(true)
        fetch("/los/signin", {
            method: "POST",
            body: tosend,
            headers: { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.status !== 200) {
                    setLoading(false)
                    trackLoginFail('password', {
                        errorText: `HTTP ${response.status}`,
                    })
                    console.log(
                        "Looks like there was a problem. Status Code: " + response.status
                    )
                    return
                }
                // Examine the text in the response
                response.json().then(async (js) => {
                    //console.log("js: " + js)
                    //console.log("js: " + JSON.stringify(js))
                    if (js.Status !== "OK") {
                        console.log("Error: " + js.Text)
                        trackLoginFail('password', { errorText: js.Text })
                        setMsg(js.Text)
                        setShow(true)
                        sessionStorage.removeItem("ZeitroA")
                        sessionStorage.removeItem("state")
                        setLoading(false)
                    } else {
                        if (remember) {
                            let inFifteenMinutes = new Date(new Date().getTime() + 72 * 3600 * 1000)
                            cookie.save("remember", { username: form.getFieldValue('email').toLowerCase(), password: form.getFieldValue('password')}, { expires: inFifteenMinutes })
                        } else {
                            cookie.remove("remember")
                        }
                        sessionStorage.setItem("ZeitroA", js.Token)
                        // now seed the local state!
                        //console.log(" state: " + js.State)

                        sessionStorage.setItem("state", js.State)
                        sessionStorage.setItem("originalstate", js.State)
                        syncLoTokenToStrataCookies(js.Token)

                        setLoading(false)
                        if (
                            checkAccessByToken(js.Token, [UR_LoanOfficerManager, UR_Owner])
                        ) {
                            updateStatsigUser(client,
                                form.getFieldValue('email'),
                                id,
                            );
                            track(STATSIG.AUTH.LOGIN, 'password', { type: 'password' })
                            // todo
                            sessionStorage.setItem("showVerificationDialog", "true");
                            await flushThenLeave(() => {
                                if(onSuccess){ 
                                   // 登陆后，通知父组件自行操作
                                   onSuccess();
                                }else {
                                    window.location.href = getRedirectUrl("/app/welcome")
                                }
                            })
                        } else if (checkAccessByToken(js.Token, [UR_LoanProcessor])) {
                            updateStatsigUser(client,
                                form.getFieldValue('email'),
                                id,
                            );
                            track(STATSIG.AUTH.LOGIN, 'password', { type: 'password' })
                            await flushThenLeave(() => {
                                window.location.href = getRedirectUrl("/app/borrowers")
                            })
                        } else if (checkAccessByToken(js.Token, [UR_Underwriter]) || checkAccessByToken(js.Token, [UR_Closer])) {
                            updateStatsigUser(client,
                                form.getFieldValue('email'),
                                id,
                            );
                            track(STATSIG.AUTH.LOGIN, 'password', { type: 'password' })
                            await flushThenLeave(() => {
                                window.location.href = getRedirectUrl("/app/borrowers")
                            })
                        } else if (checkAccessByToken(js.Token, [UR_PriceEngineUser])) {
                            updateStatsigUser(client,
                                form.getFieldValue('email'),
                                id,
                            );
                            track(STATSIG.AUTH.LOGIN, 'password', { type: 'password' })
                            await flushThenLeave(() => {
                                window.location.href = getRedirectUrl("/app/ppe-pricing")
                            })
                        } else {
                            updateStatsigUser(client,
                                form.getFieldValue('email'),
                                id,
                            );
                            track(STATSIG.AUTH.LOGIN, 'password', { type: 'password' })
                            // todo
                            sessionStorage.setItem("showVerificationDialog", "true");
                            await flushThenLeave(() => {
                                if(onSuccess){ 
                                   // 登陆后，通知父组件自行操作
                                   onSuccess();
                                } else {
                                    window.location.href = getRedirectUrl("/app/welcome")
                                }
                            })
                        }

                        //console.log(js)
                    }
                })
            })
            .catch(function (err) {
                trackLoginFail('password', {
                    errorText: err?.message || String(err),
                })
                console.log("Fetch Error :-S", err)
                setLoading(false)
            })
    }

    const handleValuesChange = (changedValues, allValues) => {
        if (changedValues.email !== undefined) {
            const email = changedValues.email?.trim()
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            setIsEmailValid(email && emailRegex.test(email))
        }
    }
    const back = (type) => {
        setShowEmailVerification(false)
        setStatus(type + 1)
    }
    const pageHeader = () => {
        if (status === 2) {
            return (
                <>
                    {isGoogain && <img src="/lender_icon/Googain_icon.png" alt="Googain" style={{ height: 72, marginBottom: 24 }} />}
                    <div className="login-title mb-4">{title ||'Sign in to your account'}</div>
                </>
            )
        } else {
            return (
                <div style={{ marginBottom: 24 }}>
                    <img src="/images/password-check.png" style={{ width: 69, height: 69, marginBottom: 11 }} />
                    <div className="login-title">{status === 3 ? 'Enter your password' : status === 4 ? 'Reset your password' : 'You are all set!'}</div>
                    {status === 5 && <div className="login-title-tips">Your password has been successfully reset,click the following to continue your access.</div>}
                </div>
            )
        }
    }
    const onChangeRemember = (e) => {
        setRemember(e.target.checked)
    }

    const getSignUpUrl = (showDomain) => {
        if (showDomain) {
            const domain = window.location.hostname
            const baseUrl = domain.includes("zeitro.us") ? "https://lo.zeitro.us" : "https://lo.zeitro.com"
            return `${baseUrl}/signup?page=plan&selectedPlan=no&${Object.entries(utmParams).map(([key, value]) => `${key}=${value}`).join('&')}`
        } else {
            return `/signup?page=plan&selectedPlan=no&${Object.entries(utmParams).map(([key, value]) => `${key}=${value}`).join('&')}`
        }
    }

    // GMCC 不允许信贷员自己注册(2025-07 起)，账号由 GMCC 管理员开
    const isGmccDomain = window.location.hostname.includes("gmccloan.com")

    const toSignup = () => {
        if(onToSignUp) return onToSignUp();
        setRedirect(<Redirect to={getSignUpUrl()} />)
    }
    const chooseCompany = (item) => {
        setShowChooseCompany(false)
        setCompanyName(item.CompanyName)
        document.title = `${item.CompanyName} - mortgage platform`
        setCustomerid(item.CustomerID)
        localStorage.setItem("customerid", item.CustomerID)
        if (operationType === 'login') {
            setLoading(true)
            window.grecaptcha.ready(() => {
                setLoading(false)
                window.grecaptcha
                    .execute(RecaptchaV3SiteKey, { action: "submit" })
                    .then((token) => {
                        login(token, item.CustomerID)
                    })
            })
        } else {
            checkEmail(item.CustomerID)
        }
    }

    // 处理 Apple/Outlook 登录的组织选择
    const chooseCompanyFromOAuth = async (item) => {
        setShowChooseCompany(false)
        setCompanyName(item.CompanyName)
        document.title = `${item.CompanyName} - mortgage platform`
        
        // 直接使用 token 登录，不需要 reCAPTCHA
        sessionStorage.setItem("ZeitroA", item.Claim)
        syncLoTokenToStrataCookies(item.Claim)
        const payload = jwt_decode(item.Claim)
        const userEmail = sessionStorage.getItem('userEmail') || ''
        
        updateStatsigUser(client, userEmail, payload.customerid, {
            orgName: item.CompanyName,
        })
        track(STATSIG.AUTH.LOGIN, oauthLoginTypeRef.current, { type: oauthLoginTypeRef.current })
        localStorage.setItem("customerid", payload.customerid)
        // window.location.href = "/app/welcome"
        await flushThenLeave(() => {
            if(onSuccess){ 
                // 登陆后，通知父组件自行操作
                onSuccess();
            } else {
                window.location.href = getRedirectUrl("/app/welcome")
            }
        })
    }

    const handleAppleSuccess = async (data) => {
        console.log("handleAppleSuccess: ", data)
        // data 包含 { companyDataList, email }
        const { companyDataList, email } = data;
        
        if (!companyDataList || companyDataList.length === 0) {
            trackLoginFail('apple', { reason: 'account_not_found' })
            setShowAccountNotFound(true)
        } else if (companyDataList.length === 1) {
            // 只有一个组织，直接登录
            const companyData = companyDataList[0];
            sessionStorage.setItem("ZeitroA", companyData.token)
            sessionStorage.setItem("state", companyData.companyName)
            sessionStorage.setItem("originalstate", companyData.companyName)
            syncLoTokenToStrataCookies(companyData.token)
            const payload = jwt_decode(companyData.token)
            updateStatsigUser(client, email, payload.customerid, {
                orgName: companyData.companyName,
            })
            track(STATSIG.AUTH.LOGIN, 'apple', { type: 'apple' })
            localStorage.setItem("customerid", payload.customerid)
            // window.location.href = "/app/welcome"
            await flushThenLeave(() => {
                if(onSuccess){ 
                    // 登陆后，通知父组件自行操作
                    onSuccess();
                } else {
                    window.location.href = getRedirectUrl("/app/welcome")
                }
            })
        } else {
            // 多个组织，显示选择界面
            oauthLoginTypeRef.current = 'apple'
            setIsOAuthLogin(true)
            setShowChooseCompany(true)
            setCompany(companyDataList.map(company => ({
                CompanyName: company.companyName,
                Claim: company.token,
                CustomerID: company.companyName // 使用 companyName 作为 CustomerID
            })))
        }
        setLoading(false)
    }

    const handleOutlookSuccess = async (data) => {
        console.log("@-handleOutlookSuccess: ", data)
        // data 包含 { companyDataList, email }
        const { companyDataList, email } = data;
        
        if (!companyDataList || companyDataList.length === 0) {
            trackLoginFail('outlook', { reason: 'account_not_found' })
            onToSignUp ? onToSignUp(email) : setShowAccountNotFound(true);
        } else if (companyDataList.length === 1) {
            // 只有一个组织，直接登录
            const companyData = companyDataList[0];
            sessionStorage.setItem("ZeitroA", companyData.token)
            sessionStorage.setItem("state", companyData.companyName)
            sessionStorage.setItem("originalstate", companyData.companyName)
            syncLoTokenToStrataCookies(companyData.token)
            const payload = jwt_decode(companyData.token)
            updateStatsigUser(client, email, payload.customerid, {
                orgName: companyData.companyName,
            })
            track(STATSIG.AUTH.LOGIN, 'outlook', { type: 'outlook' })
            localStorage.setItem("customerid", payload.customerid)
            // window.location.href = "/app/welcome"
            await flushThenLeave(() => {
                if(onSuccess){ 
                    // 登陆后，通知父组件自行操作
                    onSuccess();
                } else {
                    window.location.href = getRedirectUrl("/app/welcome")
                }
            })
        } else {
            // 多个组织，显示选择界面
            oauthLoginTypeRef.current = 'outlook'
            setIsOAuthLogin(true)
            setShowChooseCompany(true)
            setCompany(companyDataList.map(company => ({
                CompanyName: company.companyName,
                Claim: company.token,
                CustomerID: company.companyName // 使用 companyName 作为 CustomerID
            })))
        }
        setLoading(false)
    }

    const handleAppleError = (error) => {
        console.error('Apple login error:', error)
        setLoading(false)
        if (error.isAccountNotFound) {
            trackLoginFail('apple', { reason: 'account_not_found' })
            setShowAccountNotFound(true)
        } else {
            trackLoginFail('apple', {
                errorText: error?.message || error?.serverMessage,
            })
            alert('Sorry, but we are unable to sign you in using your Apple account at this time. Please consider using alternative sign-in methods.')
        }
    }

    const handleOutlookError = (error) => {
        console.error('Outlook login error:', error)
        setLoading(false)
        if (error.isAccountNotFound) {
            trackLoginFail('outlook', { reason: 'account_not_found' })
            setShowAccountNotFound(true)
        } else if (error.serverMessage) {
            // 服务端明确给出的拒绝原因（如账号被禁用）原样展示，
            // 与 Strata 的提示保持一致；兜底文案只留给本地/网络异常。
            trackLoginFail('outlook', { errorText: error.serverMessage })
            alert(error.serverMessage)
        } else {
            trackLoginFail('outlook', {
                errorText: error?.message,
            })
            alert('Sorry, but we are unable to sign you in using your Outlook account at this time. Please consider using alternative sign-in methods.')
        }
    }

    const displayImage = () => {
        return (
            <div className='los-img-box'>
                <div className='los-logo-box'>
                    {!isGoogain && <img src='/images/login-logo.png' />}
                </div>
                <div className='los-bg-box'>
                    <img src='/images/pos.png' />
                </div>
                <div className='los-img-box-content'>
                    {!isGoogain && <div className='los-img-box-content-title'>
                        We make the best loan professionals superhuman
                    </div>}
                    {/* <div className='los-img-box-content-name'>
                    Bob A, Broker owner
                    </div> */}
                    {!isGoogain && <div className='los-img-box-content-address'>
                        Zeitro is the AI powered origination platform that helps mortgage brokers close 30% more loans.
                    </div>}
                </div>
            </div>
        )
    }

    const displayCarousel = () => {
        const contentStyle = {
            width: '100%',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          };
        return (
            <div className='los-carousel-box'>
                <div className='content-box'>
                <Carousel className='create-carousel' autoplay>
                    <div>
                        <div style={contentStyle}>
                            <div className='center-box'>
                                <div>Strata AI</div>
                                <div style={{fontSize: 16, color:"#222222", fontWeight: 400, marginBottom: 20}}>AI-powered expertise across Conventional, Non-QM, FHA, VA, USDA, and Business-Purpose Loan guidelines allows you to solve complex scenarios quickly and efficiently. </div>
                                <img src='/images/carousel-img-1.svg' />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={contentStyle}>
                            <div className='center-box'>
                                <div>AI-powered efficiency</div>
                                <div style={{fontSize: 16, color:"#222222", fontWeight: 400, marginBottom: 20}}>Streamline every aspect of mortgage origination, from rate quotes to document processing, saving hours on every loan.</div>
                                <img src='/images/carousel-img-2.svg' />
                            </div>
                        </div>
                    </div>
                    {/* <div>
                        <div style={contentStyle}>
                            <div className='center-box'>
                                <div>Wholesale integration</div>
                                <div style={{fontSize: 16, color:"#222222", fontWeight: 400, marginBottom: 20}}>Automatically connect to multiple wholesalers, ensuring you always have the most competitive rates for your borrowers.</div>
                                <div >
                                    <img src='/images/carousel-img-3.svg' />
                                </div>
                            </div>
                        </div>
                    </div> */}
                </Carousel>
                </div>
            </div>
        )
    }

    return (
        <div className='los-signin-wrap'>
            {banner ? 
            <img src={banner} className="iframe-login-modal-left-img-panel" /> 
            :  <div className='los-img-box-container'>{displayImage()}</div>
            }
            <div className="sign-up-box">
                {!isGoogain && <img className='mobile-logo-svg' src='/images/logo.svg' style={{width: '90px', top: '15px', left: '20px', position: 'absolute'}} />}
                {!isGoogain && <div className="signup-link-top">
                    {description ? description :
                    <>
                        Don't have an account? {onToSignUp ?
                        <span onClick={() => onToSignUp()} style={{color:'#325CEB',cursor: 'pointer'}}>Sign up</span> :
                        <a href={getSignUpUrl(true)}>Sign up</a>}
                    </>}
                </div>}
                {redirect}
                <div className="create-account">
                    <div className="sign-up-logo">
                        {companyName !== '' && <span className="company-name">{companyName}</span>}
                    </div>
                    <div className="mobile-nav">
                        {companyName !== '' && <span className="company-name">{companyName}</span>}
                    </div>
                    {showEmailVerification ? (
                        <div className="create-centerBox">
                            <EmailVerification
                                showBack
                                fromSignIn
                                customerid={customerid}
                                email={form.getFieldValue("email").toLowerCase()}
                                back={(type) => back(type)}
                                onSuccess={onSuccess}
                            />
                        </div>
                    ) : (
                        <div className="create-centerBox">
                            {pageHeader()}

                            {status === 2 && <div className="create-centerBox-content">
                                <div style={{ marginBottom: '16px' }}>
                                    <LoginPage onSuccess={onSuccess} onToSignUp={onToSignUp} setLoading={setLoading}></LoginPage>
                                </div>
                                {/* <div style={{ marginBottom: '16px' }}>
                                    <AppleSignIn
                                        onSuccess={handleAppleSuccess}
                                        onError={handleAppleError}
                                    />
                                </div> */}
                                {!isGoogain && <div style={{ marginBottom: '16px' }}>
                                    <OutlookSignIn
                                        setLoading={setLoading}
                                        onToSignUp={onToSignUp}
                                        onSuccess={handleOutlookSuccess}
                                        onError={handleOutlookError}
                                    />
                                </div>}
                            </div>}

                            {isGoogain && (
                                <div className="help-text">
                                    Need help signing in? Contact us at <span className="blue-text" onClick={() => window.location.href = 'mailto:team@googain.com'}>team@googain.com</span>
                                </div>
                            )}
                            {!isGoogain && <Form
                                className="create-account-form"
                                layout="vertical"
                                form={form}
                                initialValues={formInitial}
                                onFinish={onFinish}
                                onValuesChange={handleValuesChange}
                                size="large"
                            >
                                {
                                    [2, 3, 4].includes(status) && (
                                        <Row>
                                            <Col span={24}>
                                                <Form.Item
                                                    name="email"
                                                    label="Email"
                                                    style={{ marginBottom: status !== 2 ? 0 : 20 }}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            type: "email",
                                                            message: 'Please enter a valid email address.',
                                                        },
                                                    ]}
                                                >

                                                    {status === 2 && <Input style={{borderRadius: '8px', height: '50px'}} placeholder="Enter your email address" />}
                                                    {(status === 3 || status === 4) && <div className="enterPwd-email"><span>{form.getFieldValue('email')}</span>{status === 3 && <span onClick={() => setStatus(2)}>Edit</span>}</div>}
                                                </Form.Item>
                                            </Col>  
                                        </Row>
                                    )
                                }
                                {status === 3 && (
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                label="Password"
                                                name="password"
                                                style={{ marginBottom: 6 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Enter your password!",
                                                    },
                                                ]}
                                            >
                                                <Input.Password placeholder="Your password" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}

                                {
                                    <Row>
                                        <Col span={24}>
                                            <RecaptchaV3 />
                                        </Col>
                                    </Row>
                                }
                                {
                                    status === 3 && (
                                        <Row className="login-operate">
                                            <Checkbox checked={remember} onChange={onChangeRemember}><span className="remember-pwd">Remember me</span></Checkbox>
                                            {/* <span className="forget-pwd" onClick={()=>window.location.href = "/forgot-password"}>Forgot password?</span> */}
                                        </Row>
                                    )
                                }
                                <Spin spinning={loading}>
                                    <div
                                        className={status === 2 && !isEmailValid ? 'disabled-create-btn' : 'create-btn sign-zeitro'}
                                        onClick={status === 2 && !isEmailValid ? null : onFinish}
                                        style={{
                                            borderRadius: '8px',
                                            width: '100%',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: status === 2 && !isEmailValid ? 'not-allowed' : 'pointer',
                                            fontFamily: 'Inter',
                                            fontSize: '18px',
                                            fontWeight: '600',
                                            lineHeight: '20px'
                                        }}
                                    >
                                        {status === 2 ? (continueText || "Continue") : "Sign in"}
                                    </div>
                                </Spin>
                                <div className="help-text">
                                    {description ? description :
                                    <>Need help signing in? Contact us at <span  className="blue-text" onClick={() => window.location.href = 'mailto:support@zeitro.com'}>support@zeitro.com</span></>
                                    }
                                </div>
                            </Form>}

                            <div className="bottom-link">
                                {status === 3 && <div>or<span onClick={signinCode}>Sign in with one-time code</span></div>}
                            </div>
                        </div>
                    )}

                    {
                        // keep an empty placeholder so justify-content: space-between still centers the login box
                        isGoogain ? <div /> : status === 3 ? (
                            <div className="create-copyright-box create-centerBox">
                                <div className="create-copyright">© {new Date().getFullYear()} Zeitro. All rights reserved.</div>
                            </div>
                        ) : (
                            <div className="create-copyright">© {new Date().getFullYear()} Zeitro. All rights reserved.</div>
                        )
                    }
                </div>
            </div>
            {/* {displayCarousel()} */}
            <Modal
                open={show}
                title="Authentication Failed"
                cancelText="Close"
                onCancel={handleClose}
                footer={(_, { CancelBtn }) => (
                    <>
                        <CancelBtn />
                    </>
                )}
            >
                <div>{msg}</div>
            </Modal>
            <Modal
                className="chooseCompany-modal"
                title={
                    isOAuthLogin 
                        ? 'Select an organization to log in'
                        : (customerIDs.length === 0
                            ? (accountDisabled ? 'Account Disabled' : 'Email Address Not Found')
                            : 'Select an organization to log in')
                }
                open={showChooseCompany}
                footer={null}
                onCancel={() => {
                    // this.editEmail('')
                    setShowChooseCompany(false)
                    setIsOAuthLogin(false)
                }
                }>
                {
                    isOAuthLogin ? (
                        // OAuth 登录（Apple/Outlook）的组织选择
                        <>
                            <div className="ft-500">{sessionStorage.getItem('userEmail')} is associated with accounts at the following orginizations, please select one to log in.</div>
                            <div className="chooseCompany-list">
                                {
                                    company.map((item, index) => (
                                        <div key={index} className="chooseCompany" onClick={() => chooseCompanyFromOAuth(item)}>
                                            <div>
                                                {
                                                    item.CustomerID in crestico_branchNamesMap ? 
                                                        crestico_branchNamesMap[item.CustomerID] 
                                                    : 
                                                        item.CompanyName
                                                }
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    ) : customerIDs.length === 0 && accountDisabled ? (
                        // 账号已停用：与后端 accountDisabledMessage 同一句，不给注册入口
                        <div>Your account is disabled, please contact your administrator.</div>
                    ) : customerIDs.length === 0 && isGmccDomain && !onToSignUp ? (
                        // GMCC 域名：不给注册入口，指向 GMCC 管理员
                        <div>{form.getFieldValue('email')} is not registered in our system. Please contact your GMCC administrator to get an account.</div>
                    ) : customerIDs.length === 0 ? (
                        // 传统登录的邮箱未找到
                        <div>{form.getFieldValue('email')} is not registered in our system. If you would like to create a new account, please <span style={{ color: '#325CEB', cursor: 'pointer' }} onClick={toSignup}>click here to sign up</span>.</div>
                    ) : (
                        // 传统登录的组织选择
                        <>
                            <div className="ft-500">{form.getFieldValue('email')} is associated with accounts at the following orginizations, please select one to log in.</div>
                            <div className="chooseCompany-list">
                                {
                                    customerIDs.map((item, index) => (
                                        <div key={index} className="chooseCompany" onClick={() => chooseCompany(item)}>
                                            <div>
                                                {
                                                    item.CustomerID in crestico_branchNamesMap ? 
                                                        crestico_branchNamesMap[item.CustomerID] 
                                                    : 
                                                        item.CompanyName
                                                }
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    )
                }
            </Modal>
            <Modal
                keyboard={false}
                className="chooseCompany-modal"
                title='Account not found'
                open={showAccountNotFound}
                footer={null}
                onCancel={() => {
                    setShowAccountNotFound(false)
                }}
            >
                <div className="py-4">
                    <div>The email address you used to sign in is not associated with any accounts in our system.</div>
                    <div className="mt-2">Please 
                        {onToSignUp ? 
                            <span onClick={onToSignUp} style={{color:'#1677ff',cursor: 'pointer'}}>sign up a new account</span> 
                            :   
                            <a href={window.location.hostname.includes('zeitro.us') ? 'https://lo.zeitro.us/signup' : 'https://lo.zeitro.com/signup'}>sign up a new account</a>}
                        , or use a different email address.</div>
                </div>
            </Modal>
        </div>
    )
}
export default withRouter(Login)
